import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ZapIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../utils/constants';
interface FloatingCTAProps {
  triggerId: string;
}
export function FloatingCTA({
  triggerId
}: FloatingCTAProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const target = document.getElementById(triggerId);
    if (!target) return;
    const observer = new IntersectionObserver(([entry]) => {
      const passed = entry.boundingClientRect.top < 0;
      setVisible(!entry.isIntersecting && passed);
    }, {
      threshold: 0
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, [triggerId]);
  return <AnimatePresence data-id="element-13" data-mp="2avbb57h9unxe">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:px-6 sm:pb-5" data-id="element-14" data-mp="38bh1o3b2u01q">
          <div className="mx-auto max-w-md sm:max-w-lg" data-id="element-15" data-mp="3342oa1rts07b">
            <a href={CHECKOUT_URL} className="flex animate-shake items-center justify-center gap-2 rounded-2xl bg-gold-500 px-4 py-4 text-center font-display text-[14px] font-black uppercase tracking-wide text-navy-950 shadow-[0_12px_28px_-6px_rgba(7,24,42,0.55)] ring-1 ring-navy-950/10 transition-colors duration-200 ease-out hover:bg-gold-600 focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold-500 sm:text-base" data-id="element-16" data-mp="335nddbvdeqxs">
              <ZapIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-17" data-mp="2bc3lavg9nx56" />
              Get instant access — $27
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}